import { render, staticRenderFns } from "./commentList.vue?vue&type=template&id=0a5341f2&scoped=true"
import script from "./commentList.vue?vue&type=script&lang=js"
export * from "./commentList.vue?vue&type=script&lang=js"
import style0 from "./commentList.vue?vue&type=style&index=0&id=0a5341f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5341f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a5341f2')) {
      api.createRecord('0a5341f2', component.options)
    } else {
      api.reload('0a5341f2', component.options)
    }
    module.hot.accept("./commentList.vue?vue&type=template&id=0a5341f2&scoped=true", function () {
      api.rerender('0a5341f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/commentList.vue"
export default component.exports